import gql from 'graphql-tag';

const storeReviewQuery = gql`
  query {
    IDS_UGC_STORE_REVIEWS_SWITCH: translation(key: "IDS_UGC_STORE_REVIEWS_SWITCH")
    IDS_UGC_STORE_REVIEW_TITLE: translation(key: "IDS_UGC_STORE_REVIEW_TITLE")
    IDS_UGC_READ_MORE_REVIEWS: translation(key: "IDS_UGC_READ_MORE_REVIEWS")
    IDS_UGC_ABOUT_US_RATINGS: translation(key: "IDS_UGC_ABOUT_US_RATINGS")
    IDS_UGC_MILLION_RATINGS: translation(key: "IDS_UGC_MILLION_RATINGS")
    IDS_UGC_ABOUT_US_GOOGLE_REVIEWS: translation(key: "IDS_UGC_ABOUT_US_GOOGLE_REVIEWS")
    IDS_UGC_ABOUT_US_DOCTOR_TEXT: translation(key: "IDS_UGC_ABOUT_US_DOCTOR_TEXT")
    IDS_UGC_WATCH_THE_VIDEO: translation(key: "IDS_UGC_WATCH_THE_VIDEO")
    IDS_UGC_STORE_REVIEW_AUTO_TRANSLATED: translation(key: "IDS_UGC_STORE_REVIEW_AUTO_TRANSLATED")
    IDS_UGC_STORE_REVIEW_SHIPPING_TITLE: translation(key: "IDS_UGC_STORE_REVIEW_SHIPPING_TITLE")
    IDS_UGC_ABOUT_US_STORE_REVIEWS: translation(key: "IDS_UGC_ABOUT_US_STORE_REVIEWS")
  }
`;

export default storeReviewQuery;
